/**
 * @constant {string} BASE_BFF_URI
 * @description Base URI path for customer BFF (Backend For Frontend) API endpoints
 */
export const BASE_BFF_URI = '/api/bff/customer';

/**
 * @function buildUri
 * @description Constructs a complete URI by combining a base path with query parameters
 * @param {string} base - The base URI to use
 * @param {Object} query - Object containing query parameters as key-value pairs
 * @throws {Error} Throws error if base URI is not provided
 * @returns {string} Complete URI with query string appended if query parameters exist
 *
 * @example
 * // Returns "/api/users?id=123&sort=asc"
 * buildUri('/api/users', { id: 123, sort: 'asc' });
 */
export function buildUri(base, query) {
  if (!base) throw new Error('buildUri() error - base URI not found');
  if (!query) return base;
  const queryStr = new URLSearchParams(query).toString();
  return `${base}?${queryStr}`;
}

/**
 * @function buildBFFUri
 * @description Constructs a customer BFF API URI with optional query parameters
 * @param {Object} query - Object containing query parameters as key-value pairs
 * @returns {string} Complete BFF URI with query string appended if query parameters exist
 *
 * @example
 * // Returns "/api/bff/customer?userId=456"
 * buildBFFUri({ userId: 456 });
 */
export function buildBFFUri(query) {
  return buildUri(BASE_BFF_URI, query);
}
